module.exports = __webpack_public_path__ + "img/slide10.7e0a54c1.png";